import { useCompanyConfig } from "@/hooks/useCompanyConfig";

export const useCompanyLogo = () => {
  const { data: companyConfig } = useCompanyConfig();

  const getLogo = () => {
    if (!companyConfig) return null;
    // Solo usar el logo claro
    return companyConfig.company_logo_url;
  };

  return {
    logoUrl: getLogo(),
    hasLightLogo: !!companyConfig?.company_logo_url,
    hasDarkLogo: false, // Ya no soportamos modo oscuro
    currentTheme: "light"
  };
}; 